export default "__VITE_ASSET__DDIKqeWa__"